import { render, staticRenderFns } from "./riskAction.vue?vue&type=template&id=62f36559"
import script from "./riskAction.vue?vue&type=script&lang=js"
export * from "./riskAction.vue?vue&type=script&lang=js"
import style0 from "./riskAction.vue?vue&type=style&index=0&id=62f36559&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f36559')) {
      api.createRecord('62f36559', component.options)
    } else {
      api.reload('62f36559', component.options)
    }
    module.hot.accept("./riskAction.vue?vue&type=template&id=62f36559", function () {
      api.rerender('62f36559', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/action/riskAction.vue"
export default component.exports